import NoticeBar from './NoticeBar';

export default NoticeBar;



// WEBPACK FOOTER //
// ./src/components/Header/components/NoticeBar/index.tsx